import { AxiosInstance, AxiosResponse } from "axios";
import { ApiResponse } from "../public-types";
import {
  AssignedContractModel,
  ContractGroupListModel,
  ContractGroupMappingRequest,
  ContractGroupModel,
  ContractGroupParam,
  CustomFieldModel,
} from "./contractgroup-type";
import { ApiPath } from "..";
import qs from "qs";

/**
 * RCR11 계약 그룹 커스텀 필드 목록 조회
 */
export const getContractGroupCustomFieldsAsync = async (
  axios: AxiosInstance,
  params?: any,
): Promise<AxiosResponse<ApiResponse<{ customFieldList: CustomFieldModel[] }>>> => {
  return await axios.get(ApiPath.contractGroup.customField.list, { params });
};

/**RCR12. 커스텀 필드 목록 등록*/
export const updateContractGroupCustomFieldsAsync = async (
  axios: AxiosInstance,
  params?: CustomFieldModel[],
): Promise<AxiosResponse<ApiResponse<{ customFieldList: CustomFieldModel[] }>>> => {
  return await axios.post(ApiPath.contractGroup.customField.add, { customFieldList: params });
};

/**RCR13. 계약그룹 조회*/
export const getContractGroupDetailAsync = async (
  axios: AxiosInstance,
  params?: { groupId: string },
): Promise<AxiosResponse<ApiResponse<{ contractGroup: ContractGroupModel }>>> => {
  return await axios.get(ApiPath.contractGroup.detail.replace("{groupId}", params?.groupId || ""));
};

/**RCR14. 계약그룹 등록*/
export const postContractGroupAsync = async (
  axios: AxiosInstance,
  params?: ContractGroupModel,
): Promise<AxiosResponse<ApiResponse<{ groupId: number }>>> => {
  // 신규 등록 시 0 전달, 수정 시 초회 groupId 전달
  const path = params?.groupId === 0 ? ApiPath.contractGroup.add : ApiPath.contractGroup.edit.replace("{groupId}", String(params?.groupId || ""));
  return await axios.post(path, { contractGroup: params });
};

/**RCR15. 계약그룹 계약매핑 조회*/
export const getContractMapOfGroupAsync = async (
  axios: AxiosInstance,
  params?: { groupId: string },
): Promise<AxiosResponse<ApiResponse<{ contractSummaryList: AssignedContractModel[]; addableContractIdList: string[] }>>> => {
  return await axios.get(ApiPath.contractGroup.assignContract.replace("{groupId}", params?.groupId || ""));
};

/**RCR16. 계약그룹 계약매핑 등록*/
export const postContractMapOfGroupAsync = async (
  axios: AxiosInstance,
  params?: { contractGroupMapList: ContractGroupMappingRequest[] },
): Promise<AxiosResponse<ApiResponse<{}>>> => {
  const groupId = params?.contractGroupMapList?.[0]?.groupId;

  return await axios.post(ApiPath.contractGroup.assignContract.replace("{groupId}", String(groupId || "")), {
    contractGroupMapList: params?.contractGroupMapList,
  });
};

/**RCR01. 계약그룹 페이징 목록 조회*/
export const getContractGroupListAsync = async (
  axios: AxiosInstance,
  params?: ContractGroupParam,
): Promise<AxiosResponse<ApiResponse<{ content: ContractGroupListModel[] }>>> => {
  return await axios.get(ApiPath.contractGroup.list, {
    params,
    paramsSerializer: {
      serialize: (params) => {
        return qs.stringify(params, { allowDots: true, encode: true });
      },
    },
  });
};
